import React, { useState } from "react";

const COLORS = [
  "#1e293b", "#0f766e", "#7c2d12", "#3730a3", "#831843",
  "#134e4a", "#1e3a8a", "#4c1d95", "#064e3b", "#78350f",
];

export default function Logo({ logoUrl, domain, title, size = 40 }) {
  // stage 0: logoUrl, stage 1: favicon, stage 2: letter avatar
  const [stage, setStage] = useState(logoUrl ? 0 : domain ? 1 : 2);
  const letter = (title || "?").trim().charAt(0).toUpperCase();
  const color = COLORS[(title || "").length % COLORS.length];
  const favicon = `https://www.google.com/s2/favicons?domain=${domain}&sz=64`;

  const src = stage === 0 ? logoUrl : favicon;
  const isLetter = stage >= 2;

  return (
    <div
      className="flex shrink-0 items-center justify-center overflow-hidden rounded-md"
      style={{ width: size, height: size, background: isLetter ? color : "hsl(var(--secondary))" }}
    >
      {isLetter ? (
        <span className="text-[15px] font-semibold text-white">{letter}</span>
      ) : (
        <img
          src={src}
          alt={title}
          width={size}
          height={size}
          onError={() => setStage((s) => s + 1)}
          className={stage === 0 ? "h-full w-full object-cover" : "h-full w-full object-contain p-1.5"}
        />
      )}
    </div>
  );
}
